import { GridBox } from '@components/grid-box';
import { Image } from '@components/image';
import { Workspace } from '@generated/graphql';
import { formatDistanceToNow } from 'date-fns';
import { navigate } from 'gatsby';
import { memo } from 'react';

type LandingPageWorkspaceCardProps = Partial<Workspace> & {
  expired: boolean;
  organizationName?: string;
};

export const LandingPageWorkspaceCard = memo(
  ({
    name,
    status,
    workspaceId,
    updatedAt,
    previewThumbnail,
    expired,
    organizationName,
  }: LandingPageWorkspaceCardProps) => {
    const title = `${name}${status !== 'ready' ? ' (Syncing)' : ''}` || '...';
    const description = `${organizationName ? `In ${organizationName} • ` : ''}${updatedAt ? `${formatDistanceToNow(updatedAt, { includeSeconds: true })} ago` : ''}`;
    return (
      <GridBox
        sx={{ height: '100%', width: '100%' }}
        title={title}
        description={description}
        onClick={() => navigate(`/workspaces/${workspaceId}`)}
        disabled={expired}
        content={<Image url={previewThumbnail} />}
      />
    );
  },
);
